import { useState, useEffect } from "react";
import Layout from "../layouts/LayoutDefault.jsx";
import MainContainer from "../components/MainContainer.jsx";
import LokultNewsPosts from "../components/LokultNewsPosts.jsx";
import SmallTitleText from "../components/SmallTitleText.jsx";
import CommercialBanner from "../components/CommercialBanner.jsx";

const LokultNewsPage = () => {
  const apiUrl = import.meta.env.VITE_API_URL_TEXTS;
  const sort = "?sort[]=-date_created";

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(apiUrl + "lokultpost" + sort);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        setData(result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [apiUrl]);

  return (
    <Layout
      title="Lokultnyheter - Nyheter från och huvudsakligen om Lokult"
      description="Nyheter som rör Lokult. Uppdateringar, nya funktioner och annat som händer på Lokult.se"
    >
      <MainContainer>
        <div className="my-8 text-center">
          <SmallTitleText text="Lokultnyheter" />
          <p className="my-2 text-xl">Se vad som händer på Lokult.se</p>
        </div>
        <div className="space-y-12 ">
          {loading ? (
            <p>Läser in nyheter...</p>
          ) : error ? (
            <p>Error: {error}</p>
          ) : (
            data.data.map((item, index) => (
              <div key={index} className="grid col-span-1 first:mt-2">
                <LokultNewsPosts post={item} />
                {index === 6 && (
                  <div className="mb-4 -mt-8">
                    <CommercialBanner />
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </MainContainer>
    </Layout>
  );
};

export default LokultNewsPage;
